document.addEventListener('DOMContentLoaded', function() {
  const initBanner = () => {
    const banners = document.querySelectorAll('.trulux-new-banner');
    
    banners.forEach(banner => {
      const leftContent = banner.querySelector('.trulux-new-banner__left');
      const rightForm = banner.querySelector('.trulux-new-banner__right');
      
      if (leftContent) {
        setTimeout(() => {
          leftContent.style.opacity = '1';
          leftContent.style.transform = 'translateY(0)';
        }, 300);
      }
      
      if (rightForm) {
        setTimeout(() => {
          rightForm.style.opacity = '1';
          rightForm.style.transform = 'translateX(0)';
        }, 500);
      }
    });
  };

  // Set initial states
  document.querySelectorAll('.trulux-new-banner__left').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'all 1s ease-out';
  });
  
  document.querySelectorAll('.trulux-new-banner__right').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateX(50px)';
    el.style.transition = 'all 1s ease-out';
  });

  initBanner();

  // Re-init for Shopify theme editor
  document.addEventListener('shopify:section:load', initBanner);
});
